import { IWheelProps } from '~/actions/extraHTML/wheelOfFortune';
import {
  decorativeElementsClass,
  desktopDiameter,
  noRotationElementsClass,
  outerShadowElementsClass,
  wheelBorderClass,
  winArrowClass,
  winArrowContainerClass
} from '~/actions/extraHTML/wheelOfFortune/const';
import { getWinArrowStyles } from '~/actions/extraHTML/wheelOfFortune/helpers';
import { arrowClass, arrowContainerClass } from '~/actions/extraHTML/wheelOfFortune/html/noRotationElements/arrow';

export const noRotationDesktopElementsStyles = (prefix: string, wheelProps: IWheelProps) => `
.${prefix}desktop_wheel_filler .${prefix}wheel_notification_desktop .${noRotationElementsClass} {
  position: absolute;
  z-index: 1;
  width: ${desktopDiameter}px;
  height: ${desktopDiameter}px;
}

.${prefix}desktop_wheel_filler .${prefix}wheel_notification_desktop .${noRotationElementsClass} .${winArrowContainerClass} {
  width: 101%;
  height: 101%;
  position: absolute;
  transform: rotate(90deg);
  z-index: 2;
  border-radius: 50%;
  overflow: hidden;
}

.${prefix}desktop_wheel_filler .${prefix}wheel_notification_desktop .${noRotationElementsClass} .${winArrowClass} {
  position: absolute;
  top: 0;
  ${getWinArrowStyles(desktopDiameter)}
}

.${prefix}desktop_wheel_filler .${prefix}wheel_notification_desktop .${noRotationElementsClass} .${arrowContainerClass} {
  width: 100%;
  height: 100%;
  position: absolute;
}

.${prefix}desktop_wheel_filler .${prefix}wheel_notification_desktop .${noRotationElementsClass} .${arrowClass} {
  position: absolute;
  z-index: 3;
}

.${prefix}desktop_wheel_filler .${prefix}wheel_notification_desktop .${noRotationElementsClass} .${outerShadowElementsClass} {
  border: 1.5px #B3B3B3 solid;
  height: ${desktopDiameter + 35}px;
  width: ${desktopDiameter + 35}px;
  border-radius: 50%;
  position: absolute;
  top: -17.5px;
  left: -17.5px;
  opacity: .5;
  filter: blur(5px);
}

.${prefix}desktop_wheel_filler .${prefix}wheel_notification_desktop .${noRotationElementsClass} .${decorativeElementsClass} {
  border: 16px white solid;
  height: ${desktopDiameter + 32}px;
  width: ${desktopDiameter + 32}px;
  border-radius: 50%;
  position: absolute;
  top: -16px;
  left: -16px;
}

.${prefix}desktop_wheel_filler .${prefix}wheel_notification_desktop .${noRotationElementsClass} .${wheelBorderClass} {
  border-radius: 50%;
  position: absolute;
  width: ${desktopDiameter}px;
  height: ${desktopDiameter}px;
  box-shadow: inset 0px 0px 9px 3px rgba(0, 0, 0, .25);
  background: linear-gradient(311.62deg, rgba(255, 255, 255, 0) 15.72%, rgba(61, 85, 121, 0.3) 102.68%);
}
`;
